module.exports = __webpack_public_path__ + "static/media/cards-screen.dad1d98e.svg";